import React from "react";
import styled, { css } from "styled-components";
import { RowContentStyles } from "components/bootstrap/Row";
export const Container = styled.div(
  ({ theme }) => css`
    ${RowContentStyles}

    padding: ${theme.spacings.lg} ${theme.spacings.md};

    @media (min-width: ${theme.breakpoints.min.sm}) {
      padding: ${theme.spacings.xl} ${theme.spacings.lg};
    }

    @media (min-width: ${theme.breakpoints.min.md}) {
      padding: ${theme.spacings.xl};
    }

    h2 {
      font-weight: bold;
    }

    p {
      margin-bottom: 9px;
      font-size: 20px;
      font-weight: normal;
    }
  `
);
const Jumbotron = ({ children, className = void 0 }) => /* @__PURE__ */ React.createElement(Container, { className }, children);
export default Jumbotron;
